<app-dialog [header]="(editMode ? 'Edit' : 'Attach') + ' associated order file' + (attachments?.length > 1 ?  's' : '') "
            [subHeader]="subheader"
            [hideHeaderUnderline]="true"
            [show]="show"
         
>
  <div 
       [ngClass]="{edit: editMode, 'with-scroll': editMode ? attachments?.length >= 5 : attachments?.length >= 4}"
  >
    <div *ngIf="editMode && !attachments?.length" class="empty-splash">
      No attachments remain.
    </div>

    <app-file-uploader *ngIf="currentStep.id === ReceiveAndSignAttachmentProgress.Attach"
                       [autoUpload]="true"
                       [multiple]="!editMode"
                       [dropFilesText]="!editMode ? 'Drag and drop files to upload' : 'Replace file'"
                       (afterFileSelected)="afterFilesSelected($event)"
    ></app-file-uploader>
    <div class="receive-attachments-dialog-container styled-main-scroll" cdk-scrollable *ngIf="currentStep.id === ReceiveAndSignAttachmentProgress.Attach">
      <div *ngFor="let item of attachments; let i = index" class="uploaded-file flex space-x-4">
        <div class="icon-container">
          <img src="assets/icons/icon-file-attachment-blue.svg" alt="attachment-icon" />
        </div>
        <div class="flex flex-col space-y-4 items-end">
          <div class="flex flex-row space-x-3 items-end">
            <div class="file-name-block">
              <div class="label">File name</div>
              <input [ngClass]="{error: !item.name || invalidInputIndexes.includes(i)}"
                (input)="fileNameChange($event, i)" [(ngModel)]="item.displayName" type="text" 
              />
              <div *ngIf="invalidInputIndexes.includes(i)" class="error-message"> File with this name already exists</div>
            </div>
            <app-dropdown-with-overlay-options-list label="Select type" (chosenOption)="fileTypeSelected($event, i)"
                [options]="fileTypes" [isOptionObject]="true" [placeholder]="'Select'"
                [(ngModel)]="item.type"
             >
            </app-dropdown-with-overlay-options-list>
            <div class="w-full" *ngIf="item.shouldShowCSOS">
              <app-input class="csos" 
                label="CSOS/DEA 222 Number"
                [formControl]="csosControl"
                #csos
              >         
              </app-input>
            </div>
          
            <app-button *ngIf="!editMode"
              (clicked)="deleteAttachment(i)" [minWidth]="38" subStyle="white" customClasses="disable-ring">
              <img class="icon-remove" src="assets/icons/icon-remove-dark-gray.svg" alt="remove-icon" />
            </app-button>
          </div>
          <app-input *ngIf="attachments[i].type === FileType.Other" class="other-type-name" [label]="'Enter file type'"
            [(ngModel)]="item.otherType"
            (valueChanged)="otherFileNameChanged($event, i)"></app-input>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="currentStep.id === ReceiveAndSignAttachmentProgress.Sign" class="pb-5 border-b">
    <app-signature-pad
      #signature 
      (drawEnd)="drawComplete($event)"
      (cleared)="signatureCleared()"
    ></app-signature-pad>
  </div>

  <div class="dialog-controls-default">
    <app-button customClasses="px-4"
                text="Cancel"
                [minWidth]="0"
                subStyle="transparent"
                class="cancel-btn"
                (clicked)="close()"
    >
    </app-button>

    <app-dot-progress-indicator *ngIf="(requiresSignature && editMode) || (requiresSignature && attachments.length)"
      [steps]="steps"
      (stepActivated)="stepSelected($event)"
      #stepper
    >
    </app-dot-progress-indicator>

    <app-button customClasses="px-4" *ngIf="!requiresSignature"
                [text]="editMode ? 'Save Changes' : 'Add files'"
                class="save-btn"
                [disabled]="(loading$ | async) || anyInvalid() || (!editMode && !attachments.length)"
                [loading]="loading$ | async"
                (clicked)="saveAttachments()"
    >
    </app-button>
    
    <div *ngIf="requiresSignature">
      <app-button customClasses="px-4" *ngIf="currentStep.id !== ReceiveAndSignAttachmentProgress.Sign && attachments.length"
        text="Next"
        class="save-btn"
        [disabled]="(loading$ | async) || anyInvalid() || (!editMode && !attachments.length)"
        [loading]="loading$ | async"
        icon="icon-chevron-white"
        [minWidth]="85"
        [iconPosition]="ButtonIconPositions.Right"
        (clicked)="selectSignStep()"
     >
      </app-button>
      <app-button customClasses="px-4" *ngIf="currentStep.id === ReceiveAndSignAttachmentProgress.Sign"
        text="Add files"
        class="save-btn"
        [disabled]="(loading$ | async) || anyInvalid() || !isSigned || !signature"
        [loading]="loading$ | async"
        [minWidth]="85"
        (clicked)="saveAttachments()"
      >
      </app-button>
  </div>
   
  </div>
</app-dialog>
